// extracted by mini-css-extract-plugin
module.exports = {"link":"styles__link___1ZZct","distributionLink":"styles__distributionLink___3pzy_","distributionLinkContainer":"styles__distributionLinkContainer___1CaM3"};